// extracted by mini-css-extract-plugin
export default {"root":"Home_root__3D9cb","pixel":"Home_pixel__Vav2i"};